// extracted by mini-css-extract-plugin
export default {"root":"PtK6rqmTHb","block":"vRX_Aut1Il","block_small":"q_u2Jp9g4V","block_large":"_gRI3H5X5W"};